/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { usePageHeaderStyles } from "@/shared";
import HeaderTitleLoader from "@/shared/components/loaders/HeaderTitleLoader";
import { useDashboardStore } from "@/stores/useDashboardStore";
import { Typography } from "@mui/material";

import { colors } from "@dotnet/telematics-design-system";

import DashboardWrapper from "../wrappers/DashboardWrapper";
import ContentContainer from "./ContentContainer/ContentContainer";
import { useStyles } from "./styles";

const Dashboard = () => {
  const { t } = useTranslation();

  const isInitialLoading = useDashboardStore(state => state.isInitialLoading);

  const { pageHeader, pageHeaderTitle } = usePageHeaderStyles(false, true);
  const { dashboardContainer } = useStyles();

  return (
    <DashboardWrapper>
      <div css={css(dashboardContainer)}>
        <div css={css({ display: "flex", width: "100%" })}>
          <div css={css(pageHeader)}>
            {isInitialLoading ? (
              <HeaderTitleLoader dashboardPage />
            ) : (
              <Typography
                variant="h6"
                css={css(pageHeaderTitle)}
                sx={{ color: colors.textDark, marginRight: "5px" }}
              >
                {t(`General##dashboard`)}
              </Typography>
            )}
          </div>
        </div>

        <ContentContainer />
      </div>
    </DashboardWrapper>
  );
};

export default Dashboard;
